import classnames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';
import { FormControlError } from '../../../core/shared/forms/useForm';
import { KeysMatching, NonEmptyArray } from '../../../utils/types';

type SelectProps<
  I extends { [key in K | V | T]: string | number } & Record<
    K | V | T | string,
    string | number | unknown
  >,
  K extends KeysMatching<T, string | number>,
  V extends KeysMatching<T, string | number>,
  T extends KeysMatching<T, string | number>
> = {
  style?: 1;
  value?: I[V];
  options: I[];
  keyProp: K;
  valueProp: V;
  textProp: T;
  errors?: NonEmptyArray<FormControlError>;
  onChange: (value: I[V]) => void;
};

export const Select = <
  I extends { [key in K | V | T]: string | number } & Record<
    string,
    string | number | unknown
  >,
  K extends KeysMatching<T, string | number>,
  V extends KeysMatching<T, string | number>,
  T extends KeysMatching<T, string | number>
>({
  style = 1,
  value,
  keyProp,
  valueProp,
  textProp,
  options,
  errors,
  onChange,
}: PropsWithChildren<SelectProps<I, K, V, T>>): ReactElement | null => {
  return (
    <select
      className={classnames(`select_style${style}`)}
      value={value}
      data-error={errors?.length ? 'error' : ''}
      onChange={(v) => {
        onChange(v.target.value as I[V]);
      }}
    >
      {options.map((option) => {
        return (
          <option key={option[keyProp]} value={option[valueProp]}>
            {option[textProp]}
          </option>
        );
      })}
    </select>
  );
};
